import DataViewer from "../pages/DataViewer";
import Dashboard from "../pages/Dashboard";
import SiteInformation from "../pages/SiteInformation";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ListIcon from "@material-ui/icons/List";
import LocationOnIcon from "@material-ui/icons/LocationOn";

const appRoutes = [
  {
    private: true,
    path: "/dashboard",
    className: "dashboardNav",
    sidebarName: "Dashboard",
    navbarName: "Dashboard",
    icon: DashboardIcon,
    component: Dashboard,
    isSidebar: true
  },
  {
    private: true,
    exact: true,
    path: "/op-data/:tabId",
    className: "opDataNav",
    sidebarName: "Operations Data",
    navbarName: "Operations Data",
    navbarTo: '/op-data/0',
    icon: ListIcon,
    component: DataViewer,
    isSidebar: true
  },
  {
    private: true,
    exact: true,
    path: "/site/:tabId",
    className: "siteInfoNav",
    sidebarName: "Site Information",
    navbarName: "Site Information",
    navbarTo: '/site/0',
    icon: LocationOnIcon,
    component: SiteInformation,
    isSidebar: true
  },
  {
    private: true,
    path: "/",
    component: Dashboard
  }
];

export default appRoutes;



// WEBPACK FOOTER //
// ./src/routes/app.js